import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Dropdown } from "react-bootstrap";
import "./user-details.css";
import DataTable from "react-data-table-component";
import axios from "../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { ThreeDot,csv_download } from "../../../assets/images";
import { CSVLink } from "react-csv";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { adminConfig } from "../../../utils/adminConfig";
import APIKeyModal from "./api-key-modal";

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};

const CorporateUserList = () => {
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [apiKeyModal, setApiKeyModal] = useState(false);
  const [passwordShowHide, setpasswordShowHide] = useState(null);
  const [members, setMembers] = useState([]);
  const [csvData, setcsvData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pagination, setPagination] = useState({
    limit: 5,
    page: 1,
    totalPage: 7,
    totalRows: 10,
  });
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [modalPassData, setModalPassData] = useState({
    uid: "",
    source: "",
  });
  const [filter, setFilter] = useState({
    source: "",
  });

  const handlePerRowsChange = (newPerPage) => {
    setLimit(newPerPage);
    setPage(1);
  };

  const handleCloseApiKeyModal = () => setApiKeyModal(false);

  const getMembers = () => {
    setLoading(true);
    axios
      .post(
        `/get-tvi-corporate-users/?limit=${limit}&page=${page}&search=${search}&filter=${filter.source}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);

        if (res.data.status) {
          setMembers(res.data.data);
          setPagination(res.data.pagination);
        } else {
          message.error("failed fetching member");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const changePage = (newPage) => {
    setPage(newPage);
  };

  const showHidePasswordFun = (id) => {
    setpasswordShowHide(id);
  };


  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      width: "100px",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      width: "200px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "150px",
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Plan Name",
    //   selector: ({ packageDetails }) => packageDetails.stripePlanName,
    //   width: "300px",
    // },
    // {
    //   name: "Plan Price",
    //   selector: ({ packageDetails }) =>
    //     packageDetails.packagePrice ? "$" + packageDetails.packagePrice : "",
    //   width: "100px",
    // },
    // {
    //   name: "Plan Status",
    //   selector: ({ isSubscriptionCanceled }) =>
    //     isSubscriptionCanceled ? "Canceled" : "Active",
    //   width: "100px",
    // },
    {
      name: "Created At",
      selector: (row) => moment(row.createdAt).format("MM-DD-YYYY"),
      sortable: true,
      width: "150px",
    },
    {
      name: "API Key",
      selector: (row) => (
        <div>
          <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  setModalPassData({
                    uid:row._id,
                    source:row.source
                  });
                  setApiKeyModal(true);
                }}
              >
                Get API Key
              </button>
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Password",
      selector: (row) => (
        <div>
          {passwordShowHide === row.id ? (
            <>
              <span>{row.passwordRaw}</span>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHidePasswordFun(null);
                }}
              >
                Hide
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHidePasswordFun(row.id);
                }}
              >
                Show
              </button>
            </>
          )}
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Action",
      selector: (row) => (
        <Dropdown drop="down" className="select_box_preassigneds">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            <img src={ThreeDot} alt="Action" />
          </Dropdown.Toggle>
          {/* <Dropdown.Menu popperConfig={popperConfig}> */}
          <Dropdown.Menu>
            
            <div
              className={`dropdown-item ${row.status ? "disabled" : ""}`}
              role="button"
              onClick={() => {
                activeInactiveUser(row.id);
              }}
            >
              Active
            </div>
            <div
              className={`dropdown-item ${!row.status ? "disabled" : ""}`}
              role="button"
              onClick={() => {
                activeInactiveUser(row.id);
              }}
            >
              Inactive
            </div>
            <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                history.push('/corporate-member-list/'+row._id);
              }}
            >
              View Member List
            </div>
          </Dropdown.Menu>
        </Dropdown>
      ),
      width: "90px",
    },
  ];

  useEffect(() => {
    getMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, search]);



  const activeInactiveUser = (id) => {
    setLoading(true);

    axios
      .post("/active-inactive-tviuser", { id }, adminConfig())
      .then((res) => {
        if (res.data.status) {
          message.success(res.data.message);
          getMembers();
        } else {
          setLoading(false);
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const downloadCSV = async () => {
    if (selectedRows.length === 0) {
      return message.warning("Please select at least one row");
    }
  const ids = selectedRows.map(row => row._id);
  setLoading(true);
  axios
      .post("/corporate-user-csv-download", { ids }, {...adminConfig(),responseType: "blob"})
      .then(async(res) => {
          setLoading(false);
          const blob = new Blob([res.data], { type: "text/csv" });     // Convert to blob
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = `corporate_members_${new Date().toISOString()}.csv`;   // File name
          a.click();

      window.URL.revokeObjectURL(url);
          message.success(res.data.message);
        
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }


  return (
    <LoadingOverlay spinner active={loading} text="Loading...">
      

      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <div className="d-flex justify-content-between w-100">
                  <h2>Registered Corporate Clients Lists</h2>
                  
                  <div className="input-group w-auto">
                   
                    <div className="form-outline">
                      <input
                        placeholder="Type name or email"
                        type="text"
                        id="form1"
                        className="form-control"
                        onChange={(e) => {
                          setQuery(e.target.value);
                        }}
                      />
                    </div>
                    <button
                      type="button"
                      className="btn btn-primary search_button"
                      onClick={() => {
                        if (query.length >= 3) {
                          setSearch(query);
                        } else {
                          message.warning(
                            "The entered input should be 3 or more than 3 characters"
                          );
                        }
                        // setPage(1);
                      }}
                    >
                      Search
                    </button>
                  </div>
                   <button className="btn btn-primary search_button" onClick={downloadCSV}>
                    Download CSV
                    </button>
                </div>


                <DataTable
                  columns={columns}
                  data={members}
                  pagination
                  striped
                  responsive
                  customStyles={customStyles}
                  subHeaderAlign="right"
                  subHeaderWrap
                  paginationDefaultPage={page}
                  paginationServer
                  paginationTotalRows={pagination.totalRows}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[5, 10, 15, 20, 40, 100]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={changePage}
                  progressComponent={<CustomLoader />}
                  noDataComponent={<EmptyDataLoader />}
                  className={members.length === 1 ? "search_state" : ""}
                  fixedHeaderScrollHeight="500px"
                  fixedHeader
                  selectableRows
                  onSelectedRowsChange={(state) => {
                    console.log(state.selectedRows)
                    setSelectedRows(state.selectedRows);
                  }}
                  dense
                />
                {apiKeyModal && (
                  <APIKeyModal apiKeyModal={apiKeyModal} handleCloseApiKeyModal={handleCloseApiKeyModal} uid={modalPassData.uid} source={modalPassData.source} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>

    //     </div>
    // </div>
  );
};
const CustomLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>Loading...</div>
  </div>
);
const EmptyDataLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    {/* <div>No data found...</div> */}
  </div>
);
export default CorporateUserList;
